/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-26 13:49:01
 * @LastEditTime: 2020-09-14 21:32:05
 * @Description: 运输单api
 */
import axios from '@/utils/axios'

export const getDelivery = (payload) => {
    return axios.get('/delivery', {
        params: payload
    })
}

export const updateDelivery = (id, data) => {
    return axios.put(`/delivery/${id}`, data)
}

export const createDelivery = (data) => {
    return axios.post(`/delivery`, data)
}

export const getDeliveryHistory = (payload) => {
    return axios.get('/delivery/list/history', {
        params: payload
    })
}

export const createDeliveryBySalesOrder = (id) => {
    return axios.get(`/delivery_by_salesorder/${id}`);
}